import { ChartTooltipProps } from '@mantine/charts';
import { Box, Group, Paper, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { FormStatusEnum, Production } from '../../data-access/types/stats';
import { chartsColors } from '../../utils/chart-colors';
import StackedBarChart from '../stacked-bar-chart/stacked-bar-chart';

import styles from './production-chart.module.css';

function ChartTooltip({ label, payload, unit }: ChartTooltipProps) {
  const { t } = useTranslation();

  if (!payload) return null;

  return (
    <Paper p="md" shadow="md" withBorder>
      <Text fw={500} mb={5}>
        {label}
      </Text>
      {payload.map((item: any) => (
        <Group justify="space-between">
          <Group>
            <Box
              style={{
                backgroundColor: item.color,
                width: 10,
                height: 10,
                borderRadius: 5,
              }}
            ></Box>
            <Text fs="sm" key={item.name}>
              {t(`common.${item.name}`)} :
            </Text>
          </Group>
          <Text fs="sm" key={item.name}>
            {item.value}
            {unit}
          </Text>
        </Group>
      ))}
    </Paper>
  );
}

interface ProductionChartProps {
  data: Production;
}

export function ProductionChart({ data }: ProductionChartProps) {
  const { t } = useTranslation();
  const { nbr_plots, total_area, ...chartData } = data;

  const formattedChartData = Object.entries(chartData).map(([name, value]) => {
    return {
      dataKey: t(`common.${name}`),
      name,
      ...value,
    };
  });

  console.log('formattedChartData', formattedChartData);

  return (
    <StackedBarChart
      data={formattedChartData}
      dataKey="dataKey"
      series={[
        { name: FormStatusEnum.FINISHED, color: chartsColors.green },
        { name: FormStatusEnum.REJECTED, color: chartsColors.red },
        { name: FormStatusEnum.UNDEFINED, color: chartsColors.yellow },
        { name: FormStatusEnum.ERROR, color: chartsColors.grey },
      ]}
      tooltipProps={{
        content: ({ label, payload }) => (
          <ChartTooltip label={label} payload={payload} unit="t" />
        ),
      }}
      unit="t"
      yAxisLabel="Tonnes"
    />
  );
}

export default ProductionChart;
